import React from 'react';
import { InputText } from 'primereact/inputtext';
import { Field } from 'formik';

export default function ContactInformationForm({ values, errors, touched, handleChange }) {
  return (
    <div className="form-section">
      <h3 className="section-title">Contact Information</h3>
      <small className="text-500 block mb-2">
        These details will help customers reach you
      </small>

      <Field name="contactEmail">
        {({ field, meta }) => (
          <div className="field">
            <label htmlFor="contactEmail">Email Address</label>
            <InputText
              id="contactEmail"
              {...field}
              className={meta.touched && meta.error ? 'p-invalid' : ''}
              placeholder="business@example.com"
            />
            {meta.touched && meta.error ? (
              <small className="p-error">{meta.error}</small>
            ) : null}
          </div>
        )}
      </Field>

      <Field name="contactPhone">
        {({ field, meta }) => (
          <div className="field">
            <label htmlFor="contactPhone">Phone Number</label>
            <InputText
              id="contactPhone"
              {...field}
              type="tel"
              className={meta.touched && meta.error ? 'p-invalid' : ''}
              placeholder="e.g., +63 912 345 6789"
              onKeyPress={(e) => {
                const allowedChars = /[0-9+\s()]/;
                if (!allowedChars.test(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {meta.touched && meta.error ? (
              <small className="p-error">{meta.error}</small>
            ) : null}
          </div>
        )}
      </Field>
    </div>
  );
}
